import { Card } from "semantic-ui-react";
import { LoginForm } from "../../../components/Admin/Auth";
import "./Auth.scss";

export function Auth() {
  return (
    <div className="auth my-20 mx-5">
      <Card className="auth__form">
        <Card.Header className="text-center">
          <h2 className="text-2xl p-5 bg-[#6E4B28] text-white font-bold">
            Iniciar sesión
          </h2>
        </Card.Header>
        <Card.Content>
          <LoginForm />
        </Card.Content>
      </Card>
    </div>
  );
}
